import classNames from 'classnames';
import { forwardRef } from 'react';
const inverseSectionCss = "imnteqe";
export const InverseSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inverseSectionCss, props.className)} />;
});

require("./inverse_section.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./inverse_section.js");